// @flow
import React from 'react';
import '../../../static/scss/components/icon.scss';

type Props = {
  className?: string,
  width?: number | null,
  icon:
    | 'current-location'
    | 'loading-wheel-primary'
    | 'green-tick'
    | 'error-cross'
    | 'facebook'
    | 'google'
    | 'thunder'
    | 'streetview'
    | 'streetview-dark'
    | 'warning'
    | 'light-bulb'
    | 'circle-correct'
    | 'circle-correct-large'
    | 'circle-incorrect'
    | 'health'
    | 'nhs'
    | 'from-until'
    | 'revolve'
    | 'info'
    | 'ev'
};

const sizes = {
  'loading-wheel-primary': {
    width: 20,
    aspectRatio: 1
  },
  'current-location': {
    width: 20,
    aspectRatio: 1
  },
  'green-tick': {
    width: 16,
    aspectRatio: 12 / 16
  },
  'error-cross': {
    width: 14,
    aspectRatio: 1
  },
  facebook: {
    width: 20,
    aspectRatio: 1
  },
  google: {
    width: 18,
    aspectRatio: 1
  },
  thunder: {
    width: 11,
    aspectRatio: 14 / 11
  },
  streetview: {
    width: 17,
    aspectRatio: 20 / 17
  },
  'streetview-dark': {
    width: 17,
    aspectRatio: 20 / 17
  },
  warning: {
    width: 36,
    aspectRatio: 32 / 36
  },
  'light-bulb': {
    width: 23,
    aspectRatio: 34 / 23
  },
  'circle-correct': {
    width: 20,
    aspectRatio: 1
  },
  'circle-correct-large': {
    width: 36,
    aspectRatio: 1
  },
  'circle-incorrect': {
    width: 20,
    aspectRatio: 1
  },
  health: {
    width: 41,
    aspectRatio: 32 / 36
  },
  nhs: {
    width: 35,
    aspectRatio: 0.5
  },
  'from-until': {
    width: 70,
    aspectRatio: 1.02
  },
  revolve: {
    width: 28,
    aspectRatio: 32 / 36
  },
  info: {
    width: 32,
    aspectRatio: 1
  },
  ev: {
    width: 32,
    aspectRatio: 1
  }
};

const Icon = ({ icon, width = null, className = '' }: Props) => {
  const { width: defaultWidth, aspectRatio } = sizes[icon];

  const iconWidth = width || defaultWidth;
  const iconHeight = aspectRatio * iconWidth;

  return (
    <span
      className={`c-icon c-icon--${icon} ${className}`}
      style={{
        width: `${iconWidth}px`,
        height: `${iconHeight}px`
      }}
    />
  );
};

export default Icon;
